export const ERROR_REPORT_SEND = 'ERROR_REPORT_SEND';
